import { APIS } from '@/constants';
import { apisUtility } from '@/utils';
import axios from 'axios';

const individualApi = {
  /**
   *
   * @param {String} token
   * @param {String} individualId
   * @returns {AxiosPromise}
   */
  requestDetail(token, individualId) {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios({
      url: `/${individualId}`,
      method: 'get',
      baseURL: APIS.BASE_URL.INDIVIDUAL,
      headers,
    });
  },
  /**
   *
   * @param {String} token
   * @param {String} individualId
   * @returns {AxiosPromise}
   */
  requestCddQuestionnaire(token, individualId) {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios({
      url: `/${individualId}/cdd_questionnaire`,
      method: 'get',
      baseURL: APIS.BASE_URL.INDIVIDUAL,
      headers,
    });
  },
  /**
   *
   * @param {String} token
   * @param {String} individualId
   * @returns {AxiosPromise}
   */
  requestDocuments(token, individualId) {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios({
      url: `/${individualId}/documents`,
      method: 'get',
      baseURL: APIS.BASE_URL.INDIVIDUAL,
      headers,
    });
  },
  /**
   *
   * @param {String} token
   * @param {String} individualId
   * @returns {AxiosPromise}
   */
  requestVideo(token, individualId) {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios({
      url: `/${individualId}/video`,
      method: 'get',
      baseURL: APIS.BASE_URL.INDIVIDUAL,
      headers,
    });
  },
  /**
   *
   * @param {String} token
   * @param {String} individualId
   * @returns {AxiosPromise}
   */
  requestDilisense(token, individualId) {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios({
      url: `/${individualId}/dilisense`,
      method: 'get',
      baseURL: APIS.BASE_URL.INDIVIDUAL,
      headers,
    });
  },
  /**
   *
   * @param {String} token
   * @param {string} individualId
   * @param {Object} data
   * @returns {AxiosPromise}
   */
  requestCreateDilisense({ token, individualId, data }) {
    const headers = {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'multipart/form-data',
    };
    return axios({
      url: `/individuals/${individualId}/newdilisense`,
      method: 'post',
      baseURL: APIS.BASE_URL.INDIVIDUAL,
      headers,
      data,
      formSerializer: { indexes: null },
    });
  },
  /**
   *
   * @param {String} token
   * @param {String} documentId
   * @returns {AxiosPromise}
   */
  requestApproveDocuments({ token, documentId }) {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios({
      url: `/documents/${documentId}/validate`,
      method: 'put',
      baseURL: APIS.BASE_URL.INDIVIDUAL,
      headers,
    });
  },
  /**
   *
   * @param {String} token
   * @param {String} videoId
   * @returns {AxiosPromise}
   */
  requestApproveFacecheckVideo({ token, videoId }) {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios({
      url: `/facecheck/video/${videoId}/validate`,
      method: 'put',
      baseURL: APIS.BASE_URL.INDIVIDUAL,
      headers,
    });
  },
  /**
   *
   * @param {String} token
   * @param {String} videoId
   * @returns {AxiosPromise}
   */
  requestApproveFacecheckDocument({ token, videoId }) {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios({
      url: `/facecheck/document/${videoId}/validate`,
      method: 'put',
      baseURL: APIS.BASE_URL.INDIVIDUAL,
      headers,
    });
  },
  /**
   *
   * @param {String} token
   * @param {String} individualId
   * @param {Object} data
   * @returns {AxiosPromise}
   */
  requestApproveProfile({ token, individualId, data }) {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios({
      url: `/${individualId}/approval-state`,
      method: 'put',
      baseURL: APIS.BASE_URL.INDIVIDUAL,
      data,
      headers,
    });
  },
  /**
   *
   * @param {String} token
   * @param {String} documentId
   * @returns {AxiosPromise}
   */
  requestDeleteDilisense(token, documentId) {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios({
      url: `/dilisense/documents/${documentId}`,
      method: 'delete',
      baseURL: APIS.BASE_URL.INDIVIDUAL,
      headers,
    });
  },
  /**
   *
   * @param {String} token
   * @returns {AxiosPromise}
   */
  requestMyAccount(token) {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios({
      url: `/my-account`,
      method: 'get',
      baseURL: APIS.BASE_URL.INDIVIDUAL,
      headers,
    });
  },
  /**
   *
   * @param {String} token
   * @returns {AxiosPromise}
   */
  requestRiskAssessmentLevels(token) {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios({
      url: '/risk-assessment-levels',
      method: 'get',
      baseURL: APIS.BASE_URL.INDIVIDUAL,
      headers,
    });
  },
  /**
   *
   * @param {String} token
   * @returns {AxiosPromise}
   */
  requestRiskAssessmentApprovalStates(token) {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios({
      url: '/risk-assessment-approval-state/list',
      method: 'get',
      baseURL: APIS.BASE_URL.INDIVIDUAL,
      headers,
    });
  },
  /**
   *
   * @param {String} token
   * @param {String} individualId
   * @returns {AxiosPromise}
   */
  requestCurrentQuestionnaire({ token, individualId }) {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios({
      url: `/${individualId}/current_questionnaire`,
      method: 'get',
      baseURL: APIS.BASE_URL.INDIVIDUAL,
      headers,
    });
  },
  /**
   *
   * @param {String} token
   * @param {String} questionnaireId
   * @returns {AxiosPromise}
   * */
  requestQuestionnaireDetail({ token, questionnaireId }) {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios({
      url: `/questionnaire/${questionnaireId}`,
      method: 'get',
      baseURL: APIS.BASE_URL.INDIVIDUAL,
      headers,
    });
  },
  /**
   *
   * @param {String} token
   * @param {Object} parameters
   * @returns {AxiosPromise}
   */
  requestRiskAssessmentList(token, parameters) {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    const params = apisUtility.bindValuedParams(parameters);
    return axios({
      url: `/individuals-risk-assessment/list`,
      method: 'get',
      baseURL: APIS.BASE_URL.INDIVIDUAL,
      headers,
      params,
    });
  },
  /**
   *
   * @param {String} token
   * @param {String} questionId
   * @param {Number} risk
   * @returns {AxiosPromise}
   */
  requestQuestionAssignrisk({ token, questionId, risk }) {
    const headers = {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'multipart/form-data',
    };
    const data = {
      risk_score: risk,
    };
    return axios({
      url: `/questionnaire/question/${questionId}/assignrisk`,
      method: 'put',
      baseURL: APIS.BASE_URL.INDIVIDUAL,
      headers,
      data,
    });
  },
  /**
   *
   * @param {String} token
   * @param {String} questionnaireId
   * @returns {AxiosPromise}
   */
  requestAssignrisk({ token, questionnaireId }) {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios({
      url: `/questionnaire/${questionnaireId}/assignrisk`,
      method: 'put',
      baseURL: APIS.BASE_URL.INDIVIDUAL,
      headers,
    });
  },
  /**
   *
   * @param {String} token
   * @param {String} questionnaireId
   * @param {Object} data
   * @returns {AxiosPromise}
   */
  requestAssignCdd({ token, questionnaireId, data }) {
    const headers = {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'multipart/form-data',
    };
    return axios({
      url: `/questionnaire/${questionnaireId}/assign-cdd`,
      method: 'put',
      baseURL: APIS.BASE_URL.INDIVIDUAL,
      headers,
      data,
    });
  },
  /**
   *
   * @param {String} token
   * @param {String} questionnaireId
   * @param {Object} data
   * @returns {AxiosPromise}
   */
  requestAssignEdd({ token, questionnaireId, data }) {
    const headers = {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'multipart/form-data',
    };
    return axios({
      url: `/questionnaire/${questionnaireId}/assign-edd`,
      method: 'put',
      baseURL: APIS.BASE_URL.INDIVIDUAL,
      headers,
      data,
    });
  },
  /**
   *
   * @param {String} token
   * @returns {AxiosPromise}
   */
  requestRiskAssessmentSummary(token) {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios({
      url: `/risk_assessment/summary`,
      method: 'get',
      baseURL: APIS.BASE_URL.INDIVIDUAL,
      headers,
    });
  },
  /**
   *
   * @param {String} token
   * @returns {AxiosPromise}
   */
  requestCddEddState(token) {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios({
      url: `/cdd-edd-state`,
      method: 'get',
      baseURL: APIS.BASE_URL.INDIVIDUAL,
      headers,
    });
  },
  /**
   *
   * @param {String} token
   * @returns {AxiosPromise}
   */
  requestRiskAssessmentState(token) {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios({
      url: `/risk-assessment-state`,
      method: 'get',
      baseURL: APIS.BASE_URL.INDIVIDUAL,
      headers,
    });
  },
};

export default individualApi;
